module.exports = __webpack_public_path__ + "static/img/bg_shengjizongheti_banner.ad5a86b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/bg_shengjizongheti_banner.png
// module id = WYc+
// module chunks = 1